import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { FinalPresentation } from '../final-presentation-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<FinalPresentation, unknown>[] = [
		buildColumn(util, 'Id', row => row.accVentureId, { header: 'accVentureId' }),
		buildColumn(util, 'Id', row => row.finalEventId, { header: 'finalEventId' }),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture' }),
		buildColumn(util, 'Text', row => row.entrepreneurs, { header: 'Entrepreneurs' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.startUTC), { header: 'Event' }),
		// buildColumn(util, 'Text', row => row.roadmapScore == 100 ? 'Complete' : row.roadmapScore == 0 ? 'Missed' : '', { header: 'Roadmap' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.deckSubmittedUTC), { header: 'Deck Submitted Date' }),
		buildColumn(util, 'Text', row => row.finalPresentationScore == 100 || row.finalPresentationScore == 50 ? 'Complete' : row.finalPresentationScore == 0 ? 'Missed' : '', { header: 'Presentation' }),
	];


	return columns;

}